'use strict'

import Vue from 'vue'
import * as type from './types'
import actions from './actions'
import getters from './getters.js'

const initialState = {
  isFetching: false,
  isShipmentDetail: false,
  error: null,
  data: {},
  marked: {},
  toggleShipments: [],
  shipmentsByDate: {},
  shipmentDetails: null,
  shipmentDetailsSchedule: [],
  shipmentDetailsDrops: [],
  shipmentSchedule: {},
  shipmentLocations: {},
  hereMapObject: null,
  shipmentFetchingError: null,
  assignDriverList: [],
  assignVehicleList: []
}

const state = {
  isFetching: false,
  isShipmentDetail: false,
  error: null,
  data: {},
  marked: {},
  toggleShipments: [],
  shipmentsByDate: {},
  shipmentDetails: null,
  shipmentDetailsSchedule: [],
  shipmentDetailsDrops: [],
  shipmentSchedule: {},
  shipmentLocations: {},
  hereMapObject: null,
  shipmentFetchingError: null,
  assignDriverList: [],
  assignVehicleList: []
}

const mutations = {
  [type.SET_SHIPMENT_IS_FETCHING] (state, action) {
    state.isFetching = action.isFetching
  },
  [type.REQUEST_LIST_SHIPMENTS] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_LIST_SHIPMENTS_SUCCESS] (state, action) {
    state.isFetching = false
    state.data = action.payload.reduce(function (acc, cur, i) {
      if (state.marked[cur.id] !== undefined) {
        cur.status = 'RUNNING'
      } else {
        cur.status = 'SCHEDULED'
      }
      acc[cur.id] = cur

      return acc
    }, {})

    state.error = null
  },

  [type.REQUEST_LIST_SHIPMENTS_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  [type.REQUEST_CREATE_SHIPMENT] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_CREATE_SHIPMENT_SUCCESS] (state, action) {
    state.isFetching = false
    state.data[action.id] = state.data[action.shipment]
    state.error = null
  },

  [type.REQUEST_CREATE_SHIPMENT_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  [type.REQUEST_DELETE_SHIPMENT] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_DELETE_SHIPMENT_SUCCESS] (state, action) {
    state.isFetching = false
    Vue.delete(state.data, action.shipmentID)
    state.error = null
  },

  [type.REQUEST_DELETE_SHIPMENT_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  [type.REQUEST_UPDATE_SHIPMENT] (state) {
    state.isFetching = true
    state.error = null
  },

  [type.REQUEST_UPDATE_SHIPMENT_SUCCESS] (state, action) {
    state.isFetching = false
    state.data[action.id] = state.data[action.shipment]
    state.error = null
  },

  [type.REQUEST_UPDATE_SHIPMENT_ERROR] (state, action) {
    state.isFetching = false
    state.error = action.error
  },
  [type.TOGGLE_SHIPMENTS2] (state, action) {
    if (action.flag) {
      state.toggleShipments.push(action.shipmentID)
    } else {
      state.toggleShipments.splice(state.toggleShipments.indexOf(action.shipmentID), 1)
    }
  },
  [type.EMPTY_TOGGLE_SHIPMENTS2] (state, action) {
    state.toggleShipments.splice(0, state.toggleShipments.length)
  },
  [type.SET_SHIPMENTS_BY_DATES] (state, payload) {
    // console.log('payload', payload)
    Object.keys(payload.data).forEach(date => {
      // console.log('date', date)
      // console.log('payload.data[date]', payload.data[date])
      // console.log(state.shipmentsByDate)
      Vue.set(state.shipmentsByDate, date, payload.data[date])
      // console.log(state.shipmentsByDate)
    })
  },
  [type.SET_SELECTED_SHIPMENT] (state, action) {
    state.shipmentDetails = { ...state.shipmentDetails, ...action.shipment }
  },
  [type.UPDATE_SELECTED_SHIPMENT_DROPS] (state, action) {
    state.shipmentDetails = { ...state.shipmentDetails, drops: action.drops }
  },
  [type.REMOVE_SELECTED_SHIPMENT] (state, action) {
    state.shipmentDetails = null
    state.shipmentDetailsSchedule = []
    state.shipmentDetailsDrops = []
    state.shipmentSchedule = {}
  },
  [type.SET_SELECTED_SHIPMENT_SCHEDULE] (state, action) {
    state.shipmentDetailsSchedule = [...action.schedule]
  },
  [type.SET_SELECTED_SHIPMENT_DETAIL_DROPS] (state, action) {
    state.shipmentDetailsDrops = [...action.drops]
  },
  [type.SET_SELECTED_SHIPMENT_LABELS] (state, action) {
    state.shipmentDetails = { ...state.shipmentDetails, labels: action.newLabels }
  },
  [type.SET_HERE_MAP_OBJECT] (state, action) {
    state.hereMapObject = { ...state.hereMapObject, ...action.hereMapObject }
  },
  [type.REMOVE_HERE_MAP_OBJECT] (state, action) {
    state.hereMapObject = null
  },
  [type.SET_SHIPMENT_SCHEDULE] (state, action) {
    state.shipmentSchedule = { ...action.schedule }
  },
  [type.SET_IS_SHIPMENT_DETAILS] (state, action) {
    state.isShipmentDetail = action.flag
  },
  [type.SET_SHIPMENT_FETCHING_ERROR] (state, action) {
    state.shipmentFetchingError = action.error
  },
  [type.SET_LOCATION_PER_SCHEDULE_STOP] (state, action) {
    if (state.shipmentLocations[action.location.id] != null) {
      Vue.set(state.shipmentLocations, action.location.id, { ...state.shipmentLocations[action.location.id], ...action.location })
    } else {
      Vue.set(state.shipmentLocations, action.location.id, action.location)
    }
  },
  [type.SET_DROP_PER_SCHEDULE_STOP] (state, action) {
    const filteredDrops = action.drops.filter(({ origin, destination }) => {
      return origin.id === action.locationID || destination.id === action.locationID
    })
    Vue.set(state.shipmentLocations, action.locationID, { ...state.shipmentLocations[action.locationID], drops: filteredDrops})
  },
  [type.SET_ASSIGN_DRIVER_LIST] (state, action) {
    state.assignDriverList = action.list
  },
  [type.SET_ASSIGN_VEHICLE_LIST] (state, action) {
    state.assignVehicleList = action.list
  },
  [type.SET_SELECTED_SHIPMENT_UNITS_COUNT] (state, action) {
    state.shipmentDetails = {...state.shipmentDetails, drops: state.shipmentDetails.drops.map((drop) => {
      const dropIndex = action.drops.findIndex((dropUnitsCount) => dropUnitsCount.id === drop.id)
      if (dropIndex >= 0) {
        return { ...drop, ...action.drops[dropIndex]  }
      }
      return {...drop}
    }) }},
  [type.SET_GOODS_VALUE_FETCHING] (state, action) {
    state.isFetching = action.isFetching
  },
  [type.GOODS_VALUE_UPDATED] (state, action) {
    state.shipmentDetails = { ...state.shipmentDetails, goodsValue: action.value }
  },
  [type.SET_RESET_STATE](state) {
    Object.assign(state, initialState)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
